import React from 'react';

import EmptyStateCard from '@/views/components/misc/EmptyStateCard';

// Utils
import { getConquestAppUrl } from '@/utils/planning';

import EnterpriseDetailInfo from '@/types/enterprise-detail-info';

type Props = {
  contactHasPlan: boolean;
  portfolioHasAccount: boolean;
  enterprise?: EnterpriseDetailInfo;
  onChangePlanAccount: () => void;
};

enum EmptyStateType {
  CONTACT_HAS_NO_PLAN = 'CONTACT_HAS_NO_PLAN',
  PORTFOLIO_HAS_NO_ACCOUNT = 'PORTFOLIO_HAS_NO_ACCOUNT',
}

export const PlanningAnalysisEmptyState: React.FC<Props> = ({ contactHasPlan, portfolioHasAccount, enterprise, onChangePlanAccount }: Props) => {
  const i18nEmptyStatePath = 'EmptyStateCard.PortfolioEditorPlanningAnalysis';
  const conquestUrl = getConquestAppUrl(enterprise);

  const emptyStateDefinition = {
    [EmptyStateType.CONTACT_HAS_NO_PLAN]: {
      titlePath: `${i18nEmptyStatePath}.ContactHasNoPlan.Title`,
      messagePath: `${i18nEmptyStatePath}.ContactHasNoPlan.Message`,
      links: conquestUrl ? [{ label: `${i18nEmptyStatePath}.ContactHasNoPlan.LinkText`, isExternalLink: true, to: conquestUrl }] : undefined,
    },
    [EmptyStateType.PORTFOLIO_HAS_NO_ACCOUNT]: {
      titlePath: `${i18nEmptyStatePath}.PortfolioHasNoAccount.Title`,
      messagePath: `${i18nEmptyStatePath}.PortfolioHasNoAccount.Message`,
      primaryButton: { label: `${i18nEmptyStatePath}.PortfolioHasNoAccount.PrimaryButtonText`, onClick: () => onChangePlanAccount() },
    },
  };

  const getEmptyStateType = () => {
    if (!contactHasPlan) {
      return EmptyStateType.CONTACT_HAS_NO_PLAN;
    }
    if (!portfolioHasAccount) {
      return EmptyStateType.PORTFOLIO_HAS_NO_ACCOUNT;
    }
  };

  const emptyStateType = getEmptyStateType();
  return <>{emptyStateType && <EmptyStateCard {...emptyStateDefinition[emptyStateType]} />}</>;
};
